module.exports = __webpack_public_path__ + "img/3.f9d18347.png";